const {
  getElements,
  viewportSize,
  prefersReducedMotion,
  isTouchDevice,
} = window.BAO.Utils

class Cursor extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: none;
      }
      :host([loaded]) {
        display: grid;
      }
    `
  }

  connectedCallback () {
    if (!this.isEnabled) return
    super.connectedCallback()
    this.setAttribute('loaded', '')
  }

  setupListeners () {
    super.setupListeners()

    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.listeners.add(document, 'mousemove', this.handleMouseMove)

    if (this.cursorContainerEls.length) {
      this.handleMouseEnter = this.handleMouseEnter.bind(this)
      this.handleMouseLeave = this.handleMouseLeave.bind(this)

      this.listeners.add(document.body, 'mouseover', event => {
        if (event.target.matches(this.customCursorContainerSelector)) {
          this.handleMouseEnter(event, event.target)
          return
        }

        this.handleMouseLeave()
      })
    }
  }

  handleMouseMove (event) {
    this.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0px)`
  }

  handleMouseEnter (event, cursorContainerEl) {
    cursorContainerEl =
      cursorContainerEl ||
      event.target.closest(this.customCursorContainerSelector)
    const cursor = cursorContainerEl?.dataset?.customCursor
    const colour = cursorContainerEl?.dataset?.customCursorColour || `dark`
    if (!cursor) return
    this.setupCursor(cursor, colour)
  }

  handleMouseLeave () {
    this.removeAttribute(`data-cursor`)

    const newContainer = document
      .elementFromPoint(event.clientX, event.clientY)
      .closest(this.customCursorContainerSelector)

    if (newContainer) {
      this.handleMouseEnter(event, newContainer)
    }
  }

  handleAttributeChange (cursorContainerEl) {
    const cursor = cursorContainerEl?.dataset?.customCursor
    const colour = cursorContainerEl?.dataset?.customCursorColour || `dark`
    if (!cursor) return
    this.setupCursor(cursor, colour)
  }

  setupCursor (cursor, colour) {
    if (!this.isEnabled) return
    this.setAttribute(`data-cursor-colour`, colour)
    this.setAttribute(`data-cursor`, cursor)
  }

  /* Custom cursor disabled on touch devices, mobile and for users who prefer reduced motion */
  get isEnabled () {
    return (
      !isTouchDevice() && !prefersReducedMotion() && viewportSize() !== 'xs'
    )
  }

  get attributeObserver () {
    return new MutationObserver(mutations => {
      const mutation = mutations.find(
        mutation =>
          mutation.type === 'attributes' &&
          mutation.attributeName === this.customCursorAttributeName,
      )
      if (!mutation) return
      this.handleAttributeChange(mutation.target)
    })
  }

  get transitionDuration () {
    return 30
  }

  get customCursorAttributeName () {
    return 'data-custom-cursor'
  }

  get customCursorContainerSelector () {
    return `[${this.customCursorAttributeName}]`
  }

  get cursorContainerEls () {
    return getElements(this.customCursorContainerSelector, {
      context: document,
    })
  }
}

if (!customElements.get('custom-cursor')) {
  customElements.define('custom-cursor', Cursor)
}
